import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { present } from '@/shared/utils/typescript';
import InvoiceFile from '../models/InvoiceFile';
import MediaFile2 from '../models/MediaFile2';
import MediaFileContent from '../models/MediaFileContent';
import MediaTargetData from '@/general/models/MediaTargetData';
import EntityType from '@/general/constants/EntityType';
import SubEntityType from '@/general/constants/SubEntityType';

const SCHEMA = {
  ...BASE_SCHEMA,
  entityType: 'entityType',
  entityId: 'entityId',
  subEntityType: 'subEntityType',
  subEntityId: 'subEntityId',
  type: (data: any) => data.mediaFileType || data.type, // dmsinvoices still have data.type instead of data.mediaFileType
  description: (data: any) => data.description ?? '',
  note: 'note',
  content: (data: any) => parseMediaFileContent(data),
};

const INVOICE_SCHEMA = {
  ...SCHEMA,
  reference: 'metaData1',
};

export function parseMediaFile2(data: any): MediaFile2 | null {
  return parseEntity(data, SCHEMA, MediaFile2);
}

export function parseMediaFiles2(data: Array<any>): Array<MediaFile2> {
  return parseEntities(data, SCHEMA, MediaFile2);
}

const CONTENT_SCHEMA = {
  original: (data: any) => data.originalContent || data.content, // invoices still have their url at data.content
  medium: 'mediumContent',
  small: 'smallContent',
  extraSmall: 'extraSmallContent',
};

export function parseMediaFileContent(data: any): MediaFileContent {
  return present(parseEntity(data, CONTENT_SCHEMA, MediaFileContent));
}

export function parseInvoiceFile(data: any): InvoiceFile | null {
  return parseEntity(data, INVOICE_SCHEMA, InvoiceFile);
}

export function parseInvoiceFiles(data: any): Array<InvoiceFile> {
  return parseEntities(data, INVOICE_SCHEMA, InvoiceFile);
}

export function formatEntityData(targetData: MediaTargetData): any {
  switch (targetData.entityType) {
    case EntityType.CONTACT_SLA:
      return { entityType: 'contactsla', entityValue: targetData.entityId };
    case EntityType.OBJECT_SLA:
      return { entityType: 'objectsla', entityValue: targetData.entityId };
    case EntityType.DOSSIER:
      return { entityType: 'attachment' };
    case EntityType.WHEELS:
      return { entityType: targetData.entityType };
    case EntityType.JOB:
      if (targetData.subEntityType === SubEntityType.DIAGNOSTIC) {
        return { entityType: targetData.subEntityType, entityValue: targetData.subEntityId };
      } else return { entityType: targetData.entityType, entityValue: targetData.entityId };
    case EntityType.DRIVE_BOOKING:
      return { entityType: targetData.entityType, entityValue: targetData.entityId };
  }
}